import React from "react";
import { useTranslation } from "locales";
import useAuthUser from "hooks/useAuthUser";
import useBreakPoints from "hooks/useBreakPoints";
import BaseButton from "components/BaseButton";
import BaseSpinner from "components/BaseSpinner";
import MediaSettings from "components/StreamView/components/RightPanel/components/MediaSettings";
import StreamPreview from "./components/StreamPreview";
import { useController } from "./controller";
import "./style.scss";

export interface Props {
  onClose: () => void;
  onSubmit: () => void;
  className?: string;
  children?: React.ReactNode;
  screenName?: string;
}

function JoinLiveChatModal({ onClose, onSubmit, className, children, screenName }: Props) {
  const { user } = useAuthUser();
  const { mobileLandscape } = useBreakPoints();
  const { t } = useTranslation();
  const {
    stream,
    mediaConstraints,
    onChangeConstraints,
    processing,
    loading,
    audioInputs,
    videoInputs,
  } = useController();

  const cls = ["join-live-chat-modal"];
  mobileLandscape && cls.push("__mobile-landscape");
  if (className) cls.push(className);

  return (
    <div className={cls.join(" ")}>
      {loading ? (
        <div className="d-center pa-6">
          <BaseSpinner size={140} />
        </div>
      ) : (
        <>
          <StreamPreview
            produceUser={user}
            stream={stream}
            constraints={mediaConstraints}
            onChangeConstraints={onChangeConstraints}
            loading={processing}
            screenName={screenName}
          />
          <div className="join-live-chat-modal__settings d-flex __column">
            <div className="headline-2 mb-3">{t("Join live chat")}</div>
            {children}
            <MediaSettings
              className="f-grow"
              loading={loading}
              audioInputs={audioInputs}
              videoInputs={videoInputs}
              onChangeConstraints={onChangeConstraints}
              constraints={mediaConstraints}
              hideTitle
            />
            <div className="join-live-chat-modal__buttons">
              <BaseButton className="join-live-chat-modal__btn" outline large onClick={onClose}>
                {t("Cancel")}
              </BaseButton>
              <BaseButton className="join-live-chat-modal__btn __join" large onClick={onSubmit}>
                {t("Join")}
              </BaseButton>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default JoinLiveChatModal;
